<template>
  <div class="container" style="margin-top: 40px;">
    <div class="row" style="text-align: left;">
      <router-link class="text-success" style="margin-right: 20px;" :to="{ name: 'Home' }">Home</router-link>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        class="bi bi-caret-right-fill"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        style="margin-right: 20px;"
      >
        <path
          d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
        />
      </svg>
      <p>{{this.$store.state.detailProduct.name}}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>